import React, { PropTypes } from 'react'
import HistoryValue from './HistoryValue'

const REQUIRED_FIELD_SYMBOL = "*";

export function Label(props) {
  const {label, required, id} = props;
  if (!label) {
    // See #312: Ensure compatibility with old versions of React.
    return <div/>;
  }
  return (
    <label className="control-label" htmlFor={id}>
      {required ? label + REQUIRED_FIELD_SYMBOL : label}
    </label>
  );
}

export default function ValmetFieldTemplate(props) {
  const {title, type, historyUnit, historyValue, historyUnit_id} = props.schema;
  //console.log(props.uiSchema);
  //console.log(props.uiSchema['ui:field']);
  const {
    id,
    label,
    children,
    classNames,
    errors,
    help,
    description,
    hidden,
    required,
    displayLabel,
    conversionTable
  } = props;
  const multifield = props.uiSchema['ui:field'] !== undefined && props.uiSchema['ui:field'] == 'multiField';
  if (hidden) {
    return children;
  }

  //<div className="history">{historyValue} {historyUnit} {children.props.formData && children.props.formData.unit}</div>

  //  console.log(conversionTable)

    return (
      <div className={classNames + (multifield ? ' valmet-fields':"")}>
        {displayLabel ? <Label label={label} required={required} id={id}/> : null}
        {displayLabel && description ? <div className="description">{description}</div>: null}

        {historyValue &&
          <HistoryValue historyUnit_id={historyUnit_id} historyValue={historyValue} historyUnit={historyUnit} selectedUnit={children.props.formData && children.props.formData.unit} conversionTable={conversionTable} />
        }

        {children}
        {errors}
        {help}
      </div>
    )
}

if (process.env.NODE_ENV !== "production") {
  ValmetFieldTemplate.propTypes = {
    id: PropTypes.string,
    classNames: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node.isRequired,
    errors: PropTypes.element,
    rawErrors: PropTypes.arrayOf(PropTypes.string),
    help: PropTypes.element,
    rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.element,
    rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    hidden: PropTypes.bool,
    required: PropTypes.bool,
    readonly: PropTypes.bool,
    displayLabel: PropTypes.bool,
    fields: PropTypes.object,
    formContext: PropTypes.object
  };
}

ValmetFieldTemplate.defaultProps = {
  hidden: false,
  readonly: false,
  required: false,
  displayLabel: true,
};




// WEBPACK FOOTER //
// ./src/components/ValmetFieldTemplate.js